<template>
	<div class="page_warp">
		<div class="top_content" style="display: table;justify-content: space-between; margin-bottom: 10px">

			<div style="display: table-row;">
				<div class="flex flex-y-center orderPicker">

					<div style="width: 300px; height: 40px">
						<el-date-picker style="width: 400px; height: 40px" v-model="dayArr" type="datetimerange"
							range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable
							@change="getData" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
						</el-date-picker>
					</div>

					<div class="top_input" style="margin-left: 120px">
						<el-input placeholder="请输入" v-model="searchWord"></el-input>
					</div>
					<div class="search_btn" @click="getData">查询</div>
					<div v-if="permissionItem.add" class="add_btn" @click="add">添加</div>
					<el-upload class="upload" action="#" :show-file-list="false" :on-change="handleExcel"
						accept="'.xlsx','.xls'" :auto-upload="false">
						<div class="add_btn mr-10" v-if="permissionItem.import">导入</div>
					</el-upload>

				</div>
			</div>

			<div style="display: table-row;">
				<div class="orderNav flex flex-y-center cursor" v-if="orderNum">
					<p :class="[changeLorstatus == '' ? 'ac' : '']" @click="changeNav('')">
						全部<!-- <span v-if="orderNum.total > 0">{{ orderNum.total }}</span> -->
					</p>
					<p :class="[changeLorstatus == '0' ? 'ac' : '']" @click="changeNav('0')">
						待接单<span v-if="orderNum.beReceived > 0">{{ orderNum.beReceived }}</span>
					</p>
					<p :class="[changeLorstatus == '1' ? 'ac' : '']" @click="changeNav('1')">
						进行中<span v-if="orderNum.afoot > 0">{{ orderNum.afoot }}</span>
					</p>
					<p :class="[changeLorstatus == '10' ? 'ac' : '']" @click="changeNav('10')">
						待审核<span v-if="orderNum.check > 0">{{ orderNum.check }}</span>
					</p>
					<p :class="[changeLorstatus == '2' ? 'ac' : '']" @click="changeNav('2')">
						完成<!-- <span v-if="orderNum.complete > 0">{{ orderNum.complete }}</span> -->
					</p>
				</div>
			</div>
		</div>
		<div class="bottom_content2">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" :key="tableKey" highlight-current-row @current-change="handleCurrentChange">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column fixed prop="lorId" label="运单号" width="110"></el-table-column>
					<el-table-column fixed prop="lorCretime" label="创建时间" width="120"></el-table-column>
					<!-- <el-table-column prop="supplierName" label="贸易商" width="120"></el-table-column> -->
					<el-table-column fixed prop="shipperName" label="托运商" width="120"></el-table-column>
					<el-table-column fixed prop="lorVehHeadNo" label="承运车辆" width="120"></el-table-column>
					<el-table-column fixed label="运单状态" width="100">
						<template #default="scope">
							<span v-if="scope.row.lorStatus == '0000'" style="color: #E36A19;">待派单</span>
							<span v-else-if="scope.row.lorStatus == '0001'" style="color: #E36A19;">待接单</span>
							<span v-else-if="scope.row.lorStatus == '0002'" style="color: #E36A19;">司机拒单</span>
							<span v-else-if="scope.row.lorStatus == '0003'" style="color: #E36A19;">待开始</span>
							<span v-else-if="scope.row.lorStatus == '0010'" style="color: #E36A19;">装货阶段</span>
							<span v-else-if="scope.row.lorStatus == '0011'" style="color: #E36A19;">待接单</span>
							<span v-else-if="scope.row.lorStatus == '0020'" style="color: #E36A19;">卸货阶段</span>
							<span v-else-if="scope.row.lorStatus == '0021'" style="color: #E36A19;">分卸阶段</span>
							<span v-else-if="scope.row.lorStatus == '0030'" style="color: #E36A19;">回程中</span>
							<span v-else-if="scope.row.lorStatus == '0100'" style="color: #E36A19;">订单待审核</span>
							<span v-else-if="scope.row.lorStatus == '1000'" style="color: #aaaaff;">订单完成</span>
							<span v-else-if="scope.row.lorStatus == '1001'">订单关闭</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="goodsName" label="商品" width="60"></el-table-column>
					<el-table-column prop="lorLoadName" label="装货地" width="120"></el-table-column>
					<el-table-column prop="lorLoadpTime" label="计划装货时间" width="120"></el-table-column>
					<el-table-column prop="lorLoadpWeight" label="计划装货吨位(吨)" width="90"></el-table-column>
					<!-- <el-table-column prop="lorLoadType" label="单/分卸">
						<template #default="scope">
							<span v-if="scope.row.lorLoadType == '0'">单装单卸</span>
							<span v-else-if="scope.row.lorLoadType == '1'">单装分卸</span>
							<span v-else>--</span>
						</template>
					</el-table-column> -->
					<el-table-column label="卸货地" width="120">
						<template #default="scope">
							<span v-for="(item, index) in scope.row.unloadords" :key="index">
								{{ item }}
								<span v-if="index < scope.row.unloadords.length - 1">,</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="odrMDirName" label="主驾" width="120"></el-table-column>
					<el-table-column prop="odrYayunName" label="押运" width="120"></el-table-column>
					<el-table-column prop="lorFreightMilage" label="运费里程(KM)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorFreightWeight" label="运费吨位(吨)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorFreightPrice" label="运费单价(元/吨/公里)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorFreightMoney" label="运费收入(元)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorOccupyIncome" label="压车费收入(元)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorUnloadIncome" label="分卸费收入(元)" width="120"
						v-if="permissionItem.fee"></el-table-column>
					<el-table-column prop="lorOtherIncome" label="其它收入(元)" width="120"
						v-if="permissionItem.fee"></el-table-column>	
					<el-table-column fixed="right" label="操作" min-width="230">
						<template #default="scope">
							<span
								v-if="(scope.row.lorStatus== '0000'||scope.row.lorStatus== '0001')&&permissionItem.edit"
								class="default_color pointer m-right10" v-on:click="edit(scope.row.lorId)">编辑</span>
							<span v-if="permissionItem.list" class="default_color pointer m-right10"
								v-on:click="detail(scope.row.lorId,0)">详情</span>
							<!-- 创建订单后，派单前可以删除	 -->
							<span v-if="scope.row.lorStatus == '0000'&&permissionItem.del"
								class="col-FF1A1A pointer m-right10" v-on:click="del(scope.row.lorId)">删除</span>
							<!-- 派单后，出发前可以取消 -->
							<span
								v-if="(scope.row.lorStatus == '0001'||scope.row.lorStatus == '0002'||scope.row.lorStatus == '0003')&&permissionItem.del"
								class="col-FF1A1A pointer m-right10" v-on:click="cancel(scope.row.lorId)">撤销</span>
							<span
								v-if="(scope.row.lorStatus == '0000'||scope.row.lorStatus == '0002')&&permissionItem.audit"
								class="defaultAC_color pointer m-right10"
								v-on:click="paidan(scope.row.lorId)">待派单</span>
							<span v-if="scope.row.loadChkCount!=0&&permissionItem.audit"
								class="defaultAC_color pointer m-right10"
								v-on:click="detail(scope.row.lorId,0)">待装货审核</span>
							<span v-if="scope.row.unloadChkCount!=0&&permissionItem.audit"
								class="defaultAC_color pointer m-right10"
								v-on:click="detail(scope.row.lorId,1)">待卸货审核</span>
							<span v-if="scope.row.expensesChkCount!=0&&permissionItem.auditfee"
								class="defaultAC_color pointer m-right10"
								v-on:click="detail(scope.row.lorId,2)">待费用审核</span>
							<span v-if="scope.row.lorFreightChkStatus==0&&permissionItem.auditfee"
								class="defaultAC_color pointer m-right10"
								v-on:click="detail(scope.row.lorId,4)">待运费审核</span>
							<span
								v-if="scope.row.lorStatus == '0100'&&scope.row.lorFreightChkStatus==1&&permissionItem.auditfinal"
								class="defaultAC_color pointer m-right10"
								v-on:click="zhongshen(scope.row.lorId)">待终审</span>
							<span
								v-if="scope.row.lorStatus == '0100'&&scope.row.lorFreightChkStatus==1&&permissionItem.reviewfee"
								class="defaultAC_color pointer m-right10"
								v-on:click="fanshen(scope.row.lorId)">运费反审</span>
							<!-- <span class="defaultAC_color pointer m-right10"
								v-on:click="trackMap(scope.row.lorId)">轨迹</span>	 -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "waybillManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();
			
			const tableKey = ref(0) // 关键：用于强制重新渲染
			const currentRow = ref();

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				changeLorstatus: "", //运单进度：空为全部 0待接单，1进行中，2已完成，3已关闭，10待审核
				orderNum: null,
				dayArr: [],

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
					audit: false,
					auditfee: false,
					auditfinal: false,
					reviewfee: false,
					fee: false,
					editfee: false,
					import: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "waybillManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "waybillManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "waybillManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "waybillManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "waybillManage:audit") {
						data.permissionItem.audit = true;
					}
					if (el == "waybillManage:auditfee") {
						data.permissionItem.auditfee = true;
					}
					if (el == "waybillManage:auditfinal") {
						data.permissionItem.auditfinal = true;
					}
					if (el == "waybillManage:reviewfee") {
						data.permissionItem.reviewfee = true;
					}
					if (el == "waybillManage:fee") {
						data.permissionItem.fee = true;
					}
					if (el == "waybillManage:editfee") {
						data.permissionItem.editfee = true;
					}
					if (el == "waybillManage:import") {
						data.permissionItem.import = true;
					}
				});
				// 强制表格重新渲染
				tableKey.value++

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight - 40;

					//data.dayArr = get24hoursRangeTime();
					getData();
					
					// setTimeout(() => {
					// 	// 强制表格重新渲染
					// 	tableKey.value++
					// }, 1000)
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							"bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询运单列表权限！");
					return;
				}

				console.log(data.dayArr);
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					lorType: 0,
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
					status: data.changeLorstatus,
				};
				const r = await proxy.$http.get(apiObj.ordList, params);
				console.log(r);
				if (r.code === 0) {
					getOrderListCount();
					r.rows.forEach((el) => {
						el.unloadords = [];
						el.unloadList.forEach((odr) => {
							el.unloadords.push(odr.lorlEndName);
							// if (el.unloadords !== null && el.unloadords !== undefined && el
							// 	.unloadords != "") {
							// 	el.unloadords = el.unloadords + odr.lorlEndName;
							// } else {
							// 	el.unloadords = odr.lorlEndName;
							// }

						});
					});
					data.tableData = r.rows;
					data.totalCount = r.total;
				}

			};

			//获取运单状态数量
			const getOrderListCount = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询运单列表权限！");
					return;
				}

				console.log(data.dayArr);
				let params = {
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.orderListCount, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.orderNum = r;
					console.log(data.orderNum);
				}

			};

			const get24hoursRangeTime = () => {
				//当前设定的日期时间
				let rangeArr = []; //定义一个装时间的数组
				let d = new Date();
				let year1, month1, day1, hour1, minutes1, seconds1;
				year1 = d.getFullYear();
				month1 = d.getMonth() + 1;
				day1 = d.getDate();
				hour1 = d.getHours();
				minutes1 = d.getMinutes();
				seconds1 = d.getSeconds();
				month1 = month1 < 10 ? '0' + month1 : month1;
				day1 = day1 < 10 ? '0' + day1 : day1;
				hour1 = hour1 < 10 ? '0' + hour1 : hour1;
				minutes1 = minutes1 < 10 ? '0' + minutes1 : minutes1;
				seconds1 = seconds1 < 10 ? '0' + seconds1 : seconds1;
				let value1 = year1 + '-' + month1 + '-' + day1 + ' ' + hour1 + ':' + minutes1 + ':' + seconds1;
				rangeArr.push(value1);
				//前一天设定的日期时间
				let year2, month2, day2, hour2, minutes2, seconds2;
				//getTime() 返回距 1970 年 1 月 1 日之间的毫秒数,setTime设置 Date 对象的日期和时间值
				d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000); //减去一天的毫秒时间，就是前一天的了
				year2 = d.getFullYear();
				month2 = d.getMonth() + 1;
				day2 = d.getDate();
				hour2 = d.getHours();
				minutes2 = d.getMinutes();
				seconds2 = d.getSeconds();
				month2 = month2 < 10 ? '0' + month2 : month2;
				day2 = day2 < 10 ? '0' + day2 : day2;
				hour2 = hour2 < 10 ? '0' + hour2 : hour2;
				minutes2 = minutes2 < 10 ? '0' + minutes2 : minutes2;
				seconds2 = seconds2 < 10 ? '0' + seconds2 : seconds2;
				let value2 = year2 + '-' + month2 + '-' + day2 + ' ' + hour2 + ':' + minutes2 + ':' + seconds2;
				rangeArr.unshift(value2);
				return rangeArr;
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有运单添加权限！");
					return;
				}

				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有运单编辑权限！");
					return;
				}

				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id, index) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有运单查询权限！");
					return;
				}

				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id, index);
				});
			};
			//菜单删除
			const del = (lorId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有运单删除权限！");
					return;
				}

				proxy
					.$confirm("您确定删除选中的运单吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.ordDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//菜单撤销
			const cancel = (lorId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有运单删除权限！");
					return;
				}

				proxy
					.$confirm("您确定撤销选中的运单吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.ordCancel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//派单
			const paidan = (lorId) => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有运单派单权限！");
					return;
				}

				proxy
					.$confirm("您确定派单选中的任务吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.ordStart, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//终审
			const zhongshen = (lorId) => {
				if (!data.permissionItem.auditfinal) {
					proxy.$message.error("没有终审权限！");
					return;
				}

				proxy
					.$confirm("您确定终审完成选中的任务吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
							remark: ''
						};
						const r = await proxy.$http.postFormData(apiObj.orderExamine, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//运费反审
			const fanshen = (lorId) => {
				if (!data.permissionItem.reviewfee) {
					proxy.$message.error("没有运费反审权限！");
					return;
				}

				proxy
					.$confirm("您确定运费反审选中的任务吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId
						};
						const r = await proxy.$http.postFormData(apiObj.orderFreightAntiChk, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//切换状态运单
			const changeNav = (val) => {

				data.changeLorstatus = val;

				// this.currentPage = 1;
				// this.tableData = [];
				getData();
			};

			// 导入
			const handleExcel = async (file) => {
				if (!data.permissionItem.import) {
					proxy.$message.error("没有导入权限！");
					return;
				}

				console.log(file);
				let formData = new FormData(); //声明一个FormDate对象
				formData.append("file", file.raw); //把文件信息放入对象中
				console.log(formData);
				await proxy.$http.uploadFileRequest(apiObj.importOrderInfo, formData, {
						headers: {
							'Content-Type': 'application/json'
						}
					}).then(res => {
						// 检查响应类型
						const contentType = res.type;
						if (contentType.includes('application/json')) {
							// 成功情况：返回JSON
							let reader = new FileReader();
							reader.readAsText(res)
							reader.onload = function(result) {
								try {
									let resData = JSON.parse(result.target
										.result); // 解析对象成功，说明是json数据
									if (resData.respCode == 0 || resData.respCode == "0000") {
										proxy.$message.success(resData.msg || resData.respMsg);
										getData();
									} else {
										proxy.$message.error(resData.msg || resData.respMsg);
									}
								} catch (err) { // 解析成对象失败，说明是正常的文件流
									proxy.$message.error(err);
								}
							};

						} else if (contentType.includes('application/octet-stream') ||
							contentType.includes('application/vnd.ms-excel')) {
							// 错误情况：返回文件流（错误报告）
							proxy.$message.error("运单导入有错误，请检查返回EXCEL表！");

							let fileName = "导入运单错误信息" + Date.parse(new Date()) + ".xls"; //这里是文件名
							proxy.$confirm("确定要导出失败的数据吗?", "提示", {
									confirmButtonText: "确定",
									cancelButtonText: "取消",
									type: "warning",
								})
								.then(() => {
									const blob = new Blob([res], {
										type: 'application/vnd.ms-excel'
									});
									if (window.navigator && window.navigator.msSaveOrOpenBlob) {
										window.navigator.msSaveOrOpenBlob(blob, fileName);
									} else {
										const link = document.createElement('a')
										link.style.display = 'none'
										link.href = URL.createObjectURL(blob)
										link.download = fileName
										document.body.appendChild(link)
										link.click()
										document.body.removeChild(link)
									}
								})
						} else {
							throw new Error(`未知的响应类型: ${contentType}`);
						}
					})
					.catch(error => {
						console.log(error);
					});
			};
			
			// 路线跳转
			const trackMap = (lorId) => {
				window.open('orderTrack?lorId='+ lorId+'&plateNo=&vehicleID=', '_blank');
				// window.open("newLinePlay.html?page=latestLocation&plateNo=" + plateNo + "&vehicleNo=" +
				// 	vehicleNo + '&vehicleID=' + vehicleID + '&iconType=' + iconType);
			};
			
			const handleCurrentChange = (val) => {
				currentRow.value = val
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				cancel,
				paidan,
				zhongshen,
				fanshen,
				changeNav,
				handleExcel,
				trackMap,
				tableKey,
				handleCurrentChange,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.orderNav {
		/* width: 100%; */
		background: #ffffff;
		border-radius: 10px;
		height: 60px;
		font-size: 16px;
		color: #333;
		/* margin-bottom: 20px; */
	}

	.orderNav p {
		margin: 0 15px;
		position: relative;
	}

	.orderNav p.ac {
		color: #e36a19;
		cursor: pointer;
	}

	.orderNav p span {
		display: block;
		width: 20px;
		height: 20px;
		background: #ff0000;
		border-radius: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		position: absolute;
		top: -10px;
		right: -10px;
	}

	.orderPicker {
		margin-top: 10px;
		height: 50px;
	}

	.orderPicker .el-range__icon {
		margin-right: 10px !important;
	}

	.cursor {
		cursor: pointer;
	}
</style>